<template>
  <v-main>
    <div id="core-view">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
    <core-footer v-show="$route.name !== 'Gis' && $route.name !== 'Ingresar'" />
  </v-main>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: 'Gis Mundo Sano'
    }
  },
}
</script>

<style>
#core-view {
  padding-bottom: 10px;
}
</style>
